import { render, staticRenderFns } from "./detection.vue?vue&type=template&id=3a4e95f5&scoped=true&"
import script from "./detection.vue?vue&type=script&lang=js&"
export * from "./detection.vue?vue&type=script&lang=js&"
import style0 from "./detection.vue?vue&type=style&index=0&id=3a4e95f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4e95f5",
  null
  
)

export default component.exports